define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');


    function AccessTokenLogin(accessToken, inResume) {
        window.lpTag = window.lpTag || {};
        var logger = WebAgentLogger.getLogger("AccessTokenLogin");
        var App = window.App || {};
        var ReLoginDialog = ViewController.extend({
            events: function() {
                window.App.agentController.bindModelParam("application", this.handleStatusChanged, this);
            },
            handleStatusChanged: function (data) {
                if (data.newValue) {
                    var status = data.newValue.status;
                    var message = data.newValue.error ? data.newValue.error.message : "";
                    var textObj;
                    if (status === "loggedOff" && message) {
                        if (message.indexOf("concurrent") !== -1) {
                            textObj = {title : "unableToLogInTitle", description : "concurrentAgentReachedError", okButton : "reconnect", cancelButton: "signOut"};
                        } else if (message.indexOf("No such agent session ID") !== -1) {
                            textObj = {title :"agentSessionTimedOutTitle", description :"agentSessionTimedOutDescription", okButton : "ok"};
                        }
                        if (textObj) {
                            this.showWindowDialog(textObj);
                        }
                    }
                }
            },
            showWindowDialog : function(textObj){
                var dialogObj = {
                    title : this.translate(textObj.title),
                    description : this.translate(textObj.description),
                    targetView : window.MainViewControllerBody,
                    modal : true,
                    xEnabled : false,
                    okButton : this.translate(textObj.okButton),
                    okCallback : login
                };
                if (textObj.cancelButton) {
                    dialogObj.cancelButton = this.translate(textObj.cancelButton);
                    dialogObj.cancelCallback = logout;
                }
                this.showDialog(dialogObj);
            }
        });

        var account = window.App.agentController.getModelParam("account");
        var reLoginDialog = new ReLoginDialog();

        if (!inResume) {
            login();
        }

        function login() {
            var logInObj = {//The object passed in for log in after we initiate the agent
                error: function () {
                    logger.error("Failed to login using an accessToken", "login");
                }
            };

            window.App.agentController.initSession({
                accessToken: accessToken,
                account: account,//Initiate the account
                success: function () {
                    logger.info("Init session with access token was successful", "initSession");
                    window.App.agentController.logInAgent(logInObj);
                },
                error: function () {
                    logger.error("Failed to init using an accessToken", "initSession");
                    reLoginDialog.showWindowDialog({title : "unableToLogInTitle", description : "unableToLogInError", okButton : "reconnect"});
                }
            });
        }

        function logout() {
            if (lpTag.WebAgent.logicController.authErrorMethod && lpTag.WebAgent.logicController.authErrorTypes) {
                lpTag.WebAgent.logicController.authErrorMethod(lpTag.WebAgent.logicController.authErrorTypes.MAX_OPERATORS_REACH);
            }

        }
    }

    return AccessTokenLogin;

});
